<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-33 md-xsmall-size-33 md-size-33">
      <div @click="gotoRoute('messages')">
        <stats-card header-color="primary">
          <template slot="header">
            <div class="card-icon">
              <i class="fa fa-envelope" />
            </div>
            <p class="category"><span style="color: #777; font-size:.85rem;" /></p>
            <h3 class="title">
              <!--<animated-number :value="numMessages"/>-->
            </h3>
          </template>

          <template slot="footer">
            <div class="stats" style="font-weight:400; font-size:.9rem;">
              <!--<md-icon>update</md-icon>-->
              Messages
            </div>
          </template>
        </stats-card>
      </div>
    </div>
  </div>
</template>

<script>
//  <div class="md-layout-item md-medium-size-33 md-xsmall-size-33 md-size-33">
//       <div @click="gotoRoute('referrals')">
//         <stats-card header-color="primary">
//           <template slot="header">
//             <div class="card-icon">
//               <!--<md-icon>store</md-icon>-->
//               <i class="fas fa-user-md" />
//             </div>
//             <p class="category"><span style="color: #777; font-size:.85rem;" /></p>
//             <h3 class="title">
//               <!--<animated-number :value="numHold"/>-->
//             </h3>
//           </template>

//           <template slot="footer">
//             <div class="stats" style="font-weight:400; font-size:.9rem;">
//               <!--<md-icon>date_range</md-icon>
//               <animated-number :value="24"></animated-number>-->
//               Referrals
//             </div>
//           </template>
//         </stats-card>
//       </div>
//     </div>

//     <div class="md-layout-item md-medium-size-33 md-xsmall-size-33 md-size-33">
//       <div @click="gotoRoute('reports')">
//         <stats-card header-color="primary">
//           <template slot="header">
//             <div class="card-icon">
//               <md-icon>assignment</md-icon>
//               <!--<i class="fas fa-notes-medical"></i>-->
//               <!--<span class="fa fa-notes-medical fa-4x"></span>-->
//             </div>
//             <p class="category"><span style="color: #777; font-size:.85rem;" /></p>
//             <h3 class="title">
//               <!--<animated-number :value="numReports"/>-->
//             </h3>
//           </template>

//           <template slot="footer">
//             <div class="stats" style="font-weight:400; font-size:.9rem;">
//               <!--<md-icon class="text-danger">warning</md-icon> -->
//               Reports
//             </div>
//           </template>
//         </stats-card>
//       </div>
//     </div>
import { StatsCard, AnimatedNumber } from "@/components"
import GlobeActivitySlimCard from "@/components/GlobeChek/Cards/GlobeActivitySlimCard.vue"
import GlobeActivitySlimTable from "@/components/GlobeChek/Tables/GlobeActivitySlimTable.vue"
export default {
  components: {
    StatsCard,
    AnimatedNumber,
    GlobeActivitySlimCard,
    GlobeActivitySlimTable
  },
  data() {
    return {
      nMessages: 0,
      nAvailable: 0,
      nOnHold: 0,
      nReports: 0
    }
  },
  computed: {
    numMessages() {
      return sessionStorage.getItem("doctorMessages")
    },
    numAvailable() {
      return sessionStorage.getItem("doctorAvailable")
    },
    numHold() {
      return sessionStorage.getItem("doctorHold")
    },
    numReports() {
      return sessionStorage.getItem("doctorReports")
    }
  },
  created: function() {
    // this.$store.dispatch('loadDoctorInfo')
  },
  mounted: function() {
    this.$nextTick(function() {
      this.initDash()
      //this.renderComponent = true;
    })
  },
  methods: {
    gotoRoute(r) {
      this.$router.push("/portal/doctor/" + r)
    },
    initDash() {
      this.nMessages = sessionStorage.getItem("doctorMessages")
      this.nAvailable = sessionStorage.getItem("doctorAvailable")
      this.nOnHold = sessionStorage.getItem("doctorHold")
      this.nReports = sessionStorage.getItem("doctorReports")
    }
  }
}
</script>
<style lang="scss" scoped>
.md-table {
  height: 85vh;
  overflow: auto;
}
</style>
